import request from "root/js/request";

export const getTransitWarehouses = async () => {
  const response = await request({
    url: `analytics/wh_supply/transit_warehouses/`,
    method: "get",
  });
  return response.data;
};
